import React, { Fragment, useCallback, useState, useEffect, useRef } from 'react';
import { useDispatch } from 'redux-react-hook';
import { formatSeconds, formatDuration } from 'utils/time';
import classNames from 'classnames';
import ReactPlayer from 'react-player'

import { playNext } from 'store/modules/player/actions';

export default function ProgressBar({ queue, song, playing, token, repeat, muted }) {
  const player = useRef(null);
  const dispatch = useDispatch();
  const [progress, setProgress] = useState(0);
  const [loaded, setLoaded] = useState(0);
  const [seconds, setSeconds] = useState('00:00');
  const [duration, setDuration] = useState(formatDuration(song.duration));
  const url = song.sound.url ? song.sound.url : song.sound;

  const onProgress = useCallback((status) => {
    setLoaded(Math.ceil(status.loaded * 100));
    setProgress(Math.ceil(status.played * 100));
    setSeconds(formatSeconds(status.playedSeconds));
  }, [song]);
  const onSeek = useCallback((value) => {
    player.current.seekTo(value, 'fraction')
  }, [song]);
  const onEnded = useCallback(() => {
    dispatch(playNext(song, queue));
  }, [song, queue, repeat]);
  useEffect(() => {
    setDuration(formatDuration(song.duration));
    setLoaded(0)
    setProgress(0)
  }, [song])

  return (
    <Fragment>
      <div className="Player_progress flex">
        <Timer time={seconds} direction="left" />
        <Bar progress={progress} loaded={loaded} onSeek={onSeek} />
        <Timer time={duration} />
      </div>
      <ReactPlayer
        ref={player}
        url={`${url}?token=${token}`}
        playing={playing}
        config={{
          file: { forceAudio: true },
        }}
        loop={repeat === 'one'}
        onProgress={onProgress}
        onEnded={onEnded}
        muted={muted}
        width="100%"
        height="1px"
      />
    </Fragment>
  );
}

function Timer({ direction, time }) {
  return (
    <div
      style={{ width: 55 }}
      className={classNames('text-secondary text-xs font-sans', {
        'text-right pr-2': direction === 'left',
        'text-left pl-2': direction !== 'left',
      })}
    >
      {time}
    </div>
  );
}

function Bar({ progress, loaded, onSeek }) {
  const bar = useRef(null);
  const onClick = useCallback((event) => {
    if (onSeek) {
      const total = bar.current.offsetWidth;
      const current = event.nativeEvent.offsetX;
      const value = current / total;

      onSeek(value)
    }
  }, [onSeek, bar.current]);
  return (
    <div className="flex-1" style={{ height: '4px', marginTop: '5px' }}>
      <div className="bg-thumbnail rounded">
        <div ref={bar} onClick={onClick} className="bg-neutral rounded cursor-pointer" style={{ width: `${loaded}%`, height: '4px' }}>
          <div className="bg-primary rounded" style={{ width: `${progress}%`, height: '4px' }} />
        </div>
      </div>
    </div>
  );
}